import controller from './folders-and-labels.controller';

const template = require('./folders-and-labels.html');

export default {
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/folders-and-labels.component.js